import { useState } from 'react'

import GuideHeroSection from '@/components/sections/guide/GuideHeroSection'
import ManualSection from '@/components/sections/guide/ManualSection'
import { useData } from '@/hooks/useLocale'
import { useTitle } from '@/hooks/useTitle'

/** The Features Guide: a photo hero with a search box, then the manual it searches. */
export default function GuidePage() {
  const { GUIDE } = useData()
  const [query, setQuery] = useState('')
  useTitle(GUIDE.eyebrow)

  return (
    <>
      <GuideHeroSection query={query} onQuery={setQuery} />
      <ManualSection query={query} onClear={() => setQuery('')} />
    </>
  )
}
